import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'

type TModalProps = {
  id: number
}

export const useUserToOrganizationDiscountDelete = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.userToOrganizationDiscountDelete)

  const id = useSelector(({ modals }: TState) => (modals.data as TModalProps).id)

  const onSubmit = () => {
    dispatch(Actions_CurrentUser.saga.removeOrganizationDiscountConnection({ id }))
    dispatch(Actions_Modals.store.hideModal())
  }

  const onCancel = () => dispatch(Actions_Modals.store.hideModal())

  return { t, onSubmit, onCancel }
}
